import React from "react";
import YouTube from "react-youtube";

export const PlayerDevice = ({ initialId, events }) => {
    const { onReady, onPlay, onPause, onEnd, onError, onStateChange } = events;
    const opts = {
        height: '340',
        width: '100%',
        playerVars: {},
    };
    return <YouTube
        opts={opts}
        videoId={initialId}
        id='video-player'
        containerClassName='video-player'
        onReady={onReady}
        onPlay={onPlay}
        onPause={onPause}
        onEnd={onEnd}
        onError={onError}
        onStateChange={onStateChange}
    />
}
